(function () {

    const SelectorsDictionary = {
        CheckoutButton: 'button.hpe-cart-summary__continue.js-continue-checkout-button',
        HeaderCheckout: 'a#request_checkout',
        HeaderCheckoutMenuItem: 'li#hpehf-cart',
        PurchaseTabButton: 'div#hpe-mini-cart-container ul li#purchase_tab_button',
    }

    function isLoggedIn() {
        return $('div#hpe-store-signed-in-indicator').text().length > 0;
    }

    /**
     * Submits a POST request to the guest checkout form to skip login
     */
    function submitGuestCheckout() {
        const baseUrl = window['feHPEB2C']?.baseUrl() || '';
        const guestCheckoutUrl = baseUrl + '/login/checkout/guest';

        // Get the CSRF token from the page
        const csrfInput = document.querySelector('input[name="CSRFToken"]');
        const csrfToken = csrfInput ? csrfInput.value : '';

        window.feHPEB2C?.log('FE:4063 - Submitting guest checkout POST to:', guestCheckoutUrl);

        // Create a hidden form and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = guestCheckoutUrl;
        form.style.display = 'none';

        // Add email field (empty for guest)
        const emailInput = document.createElement('input');
        emailInput.type = 'hidden';
        emailInput.name = 'email';
        emailInput.value = '';
        form.appendChild(emailInput);

        // Add CSRF token
        const csrfField = document.createElement('input');
        csrfField.type = 'hidden';
        csrfField.name = 'CSRFToken';
        csrfField.value = csrfToken;
        form.appendChild(csrfField);

        document.body.appendChild(form);
        form.submit();
    }

    /**
     * Updates the checkout button to skip the login step
     * and overrides the native click handler
     */
    function updateCheckoutUrl() {
        if (isLoggedIn()) return;
        const checkoutButton = document.querySelector(SelectorsDictionary.CheckoutButton);
        if (!checkoutButton) {
            return;
        }

        window.feHPEB2C?.log('FE:4063 - Overriding checkout button to use guest checkout');

        $(SelectorsDictionary.CheckoutButton)
            .removeClass('js-continue-checkout-button')
            .addClass('fe-js-continue-checkout-button')
            .off('click')
            .click(function (e) {
                e.preventDefault();
                submitGuestCheckout();
            });
    }

    /**
     * Replaces the header checkout link with our custom button
     */
    function replaceHeaderCheckout() {
        window.feHPEB2C?.log('FE:4063 replaceHeaderCheckout()');
        const headerCheckout = document.querySelector(SelectorsDictionary.HeaderCheckout);
        if (!headerCheckout || headerCheckout.dataset.feReplaced) {
            return;
        }
        if (isLoggedIn()) return;

        const newCheckoutButton = `<button  
class=" checkout   fe-js-continue-checkout-button fe-4063-hdr-checkout-btn" 
id="request_checkout"
data-checkout-url="/login/checkout/guest">
								Check Out <span class="hpehf-white-arrow visible"></span>
							</button>`;

        window.feHPEB2C?.log('FE:4063 - Overriding header checkout to use guest checkout');

        $(SelectorsDictionary.HeaderCheckout).replaceWith(newCheckoutButton);

        $('.fe-4063-hdr-checkout-btn')
            .off('click')
            .click(function (e) {
                e.preventDefault();
                submitGuestCheckout();
            });
    }

    /**
     * Shows or hides the custom header checkout button based on whether
     * the purchase tab button has the active class
     */
    function syncCheckoutButtonVisibility() {
        const isActive = $(`${SelectorsDictionary.PurchaseTabButton}.active`).length > 0;
        const btnCheckout = $('button.fe-4063-hdr-checkout-btn')
        if (!btnCheckout.length) {
            return;
        }
        if ($('a.hpehf-cart-more-items-text').is(':visible')) {
            $(btnCheckout).addClass('disable');
        }else{
            $(btnCheckout).removeClass('disable');
        }
        $(btnCheckout).toggle(isActive);
    }

    /**
     * Sets up a MutationObserver to watch for the header checkout link
     * which only appears after the user clicks on the cart menu item,
     * and to sync the checkout button visibility with the purchase tab state
     */
    function observeHeaderCheckout() {
        window.feHPEB2C?.log('FE:4063 observeHeaderCheckout()');

        // Try to replace immediately in case it already exists
        replaceHeaderCheckout();
        syncCheckoutButtonVisibility();

        // Set up observer to watch for the checkout link appearing
        // and for class changes on the purchase tab button
        const observer = new MutationObserver(function () {
            const headerCheckout = document.querySelector(SelectorsDictionary.HeaderCheckout);
            if (headerCheckout) {
                replaceHeaderCheckout();
            }
            syncCheckoutButtonVisibility();
        });

        // Observe the body for added nodes and class attribute changes
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
        });

        window.feHPEB2C?.log('FE:4063 - MutationObserver set up for header checkout');
    }

    window.feUtils.waitForConditions({
        conditions: [SelectorsDictionary.CheckoutButton],
        activity: feProjectId,
        callback: updateCheckoutUrl,
    })

    // Set up observer immediately since we're watching the body
    observeHeaderCheckout();

})();
